export default function transformContrat(contrat) {
  if (contrat.dateDebutSignature != null) {
    contrat.dateDebutSignature = new Date(contrat.dateDebutSignature);
    contrat.dateSignature = contrat.dateSignature ? new Date(contrat.dateSignature)
      : new Date(contrat.dateDebutSignature);
  }
  if (contrat.dateFinSignature != null) {
    contrat.dateFinSignature = new Date(contrat.dateFinSignature);
  }
  if (contrat.dateDebutEcheance != null) {
    contrat.dateDebutEcheance = new Date(contrat.dateDebutEcheance);
  }
  if (contrat.dateFinEcheance != null) {
    contrat.dateFinEcheance = new Date(contrat.dateFinEcheance);
  }
  if (contrat.dateIndexationReference != null) {
    contrat.dateIndexationReference = new Date(contrat.dateIndexationReference);
  }
  if (contrat.dateIndexationActuel != null) {
    contrat.dateIndexationActuel = new Date(contrat.dateIndexationActuel);
  }
  if (contrat.dateDerniereIndexation != null) {
    contrat.dateDerniereIndexation = new Date(contrat.dateDerniereIndexation);
  }
  if (contrat.datePreavis != null) contrat.datePreavis = new Date(contrat.datePreavis);

  contrat.contratsMateriels.forEach((contratMateriel) => { contratMateriel.logo = null; });

  contrat.intervenants.forEach((intervenant) => {
    intervenant.selected = true;
    intervenant.mustAppearInEcheanceList = true;
  });
  if (contrat.reglesAchat) {
    contrat.reglesAchat.forEach((el) => {
      el.dateDebut = new Date(el.dateDebut);
      if (el.dateFin) el.dateFin = new Date(el.dateFin);
      el.selected = false;
    });
  }

  return contrat;
}
